import React from 'react';
import { componentService } from 'js/services/component.service';

export const TermsAndConditionsHistory = React.lazy(() => import(/* webpackChunkName: "terms-and-conditions-history" */ './TermsAndConditionsHistory'));

// <hub2-terms-and-conditions-history></hub2-terms-and-conditions-history>
componentService.registerWebContentComponents({ TermsAndConditionsHistory });
